// Thin fetch wrapper that attaches the stored JWT and reacts to 401s.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "ps_auth_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export async function apiFetch(input, options = {}) {
  const token = getToken();
  const headers = { ...(options.headers || {}) };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const url =
    typeof input === "string" && input.startsWith("http")
      ? input
      : `${BACKEND_URL}${input}`;
  const res = await fetch(url, { ...options, headers });
  if (res.status === 401) {
    clearToken();
    window.dispatchEvent(new Event("ps-unauthorized"));
  }
  return res;
}
